<template>
  <div>
    <app-cells>
      <h1 class="title">Altezza Transfers</h1>
    </app-cells>
    <app-tabs :tabs="tabs" />
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import AppTabs from '@/components/AppTabs'

export default {
  name: 'CalculatorLayout',
  components: { AppTabs },
  data() {
    return {
      tabs: [
        { name: 'transfer-regular', label: 'Regular transfer' },
        { name: 'transfer-advanced', label: 'Advanced transfer' },
      ]
    }
  },
}
</script>
